import { t } from "@lingui/macro";
import { useSetAtom } from "jotai";
import { useCallback } from "react";

import { Button } from "@whoosh/design-system/src/components/controls";
import { PersonFilledIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import { Text, VStack } from "@whoosh/design-system/src/components/primitive";

import { ProceedToAccessYourAccountStepAtom } from "../../../../atoms/actions";

export const LearnMore = ({
  emailOrPhone,
}: {
  emailOrPhone: string | null;
}) => {
  const goToAccessYourAccount = useSetAtom(ProceedToAccessYourAccountStepAtom);
  const handleLearnMore = useCallback(() => {
    goToAccessYourAccount({ emailOrPhone: emailOrPhone ?? "" });
  }, [goToAccessYourAccount, emailOrPhone]);

  return (
    <VStack
      gap={4}
      alignItems="center"
      backgroundColor={"surface-secondary"}
      padding={4}
      borderRadius="4"
    >
      <PersonFilledIcon />
      <VStack>
        <Text
          variant={"mainBaseMedium"}
          color="text-primary"
          textAlign="center"
        >
          {t`Are you trying to access your`}
        </Text>
        <Text
          variant={"mainBaseSemiBold"}
          color="text-primary"
          textAlign="center"
        >{t`Private Club account?`}</Text>
      </VStack>
      <Button
        size="small"
        accessibilityLabel={t`Learn More`}
        testID="learn-more-button"
        width="100%"
        variant="white"
        onPress={handleLearnMore}
      >{t`Learn More`}</Button>
    </VStack>
  );
};
